module.exports = __webpack_public_path__ + "img/iot5.9d848c82.png";